module.exports = __webpack_public_path__ + "static/img/swiperadmin4.01857a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/swiperadmin4.png
// module id = 9Shz
// module chunks = 1